import * as CheckboxPrimitive from "@radix-ui/react-checkbox";
import { cn } from "@theprelude/core";
import { forwardRef, useId } from "react";
import { CheckmarkIcon } from "../icons/checkmark-icon";

export type CheckboxProps = Omit<
  CheckboxPrimitive.CheckboxProps,
  "onChange"
> & {
  readOnly?: boolean;
};

export const Checkbox = forwardRef<HTMLButtonElement, CheckboxProps>(
  function Checkbox({ className, ...props }, ref) {
    return (
      <CheckboxPrimitive.Root
        ref={ref}
        {...props}
        disabled={props.disabled || props.readOnly}
        className={cn(
          "apperance-none bg-primary-background border-stroke-input dark:data-[state=checked]:bg-blue-bay data-[state=checked]:bg-tertiary-background focus-visible:ring-stroke-input size-4 shrink-0 rounded border p-0 shadow focus-visible:outline-none focus-visible:ring-2 data-[state=checked]:border-transparent",
          className,
        )}
      >
        <CheckboxPrimitive.Indicator className="flex items-center justify-center text-white">
          <CheckmarkIcon className="size-4" />
        </CheckboxPrimitive.Indicator>
      </CheckboxPrimitive.Root>
    );
  },
);

export interface LabeledCheckboxProps extends CheckboxProps {
  label: string;
}

export const LabeledCheckbox = forwardRef<
  HTMLButtonElement,
  LabeledCheckboxProps
>(function LabeledCheckbox({ label, ...props }, ref) {
  const defaultId = useId();
  const id = props.id || defaultId;

  return (
    <div className="flex items-center">
      <Checkbox ref={ref} {...props} id={id} />
      <label
        htmlFor={id}
        className={cn(
          "cursor-pointer pl-2",
          props.disabled && "text-secondary-foreground cursor-not-allowed",
        )}
      >
        {label}
      </label>
    </div>
  );
});
